import { AbstractModel } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { Organization } from './organization';

@inheritSerialization(AbstractModel)
export class TransitProgramInfo {
  @autoserialize
  id: number;

  @autoserialize
  name: string;

  @autoserialize
  code: string;

  @autoserialize
  timeZone: string;

  @autoserialize
  latitude: number;

  @autoserialize
  longitude: number;

  @autoserialize
  active: boolean;

  @autoserializeAs(Organization)
  organization: Organization;

  @autoserialize
  driverCallCenterPhoneNumber: string;

  @autoserialize
  riderCallCenterPhoneNumber: string;

  @autoserialize
  riderCancellationWindowMinutes: number;

  @autoserialize
  providerCancellationWindowMinutes: number;

  @autoserialize
  lyftAutoDispatchEnabled: boolean;

  @autoserialize
  distanceToPickUpEstimateRequired: boolean;

  @autoserialize
  nonEmergencyPhoneNumber: string;

  @autoserialize
  rideReviewEnabled: boolean;
}
